import { Routes } from '@angular/router';
// import { userGuard } from './guards/user.guard';
import { AuthComponent } from './features/auth/auth.component';
import { UserComponent } from './features/user/user.component';
import { userRoutes } from './features/user/user.routes';

export const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    loadChildren: () =>
      import('./features/auth/auth-routing.module').then((m) => m.AuthRoutingModule),
  },
  {
    path: '',
    component: UserComponent,
    children: userRoutes,
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
